// extracted by mini-css-extract-plugin
export var graphic = "WhatWeAreBuilding-module--graphic--264Wg";
export var keyword = "WhatWeAreBuilding-module--keyword--1I6nK";
export var word = "WhatWeAreBuilding-module--word--32yet";
export var arrow = "WhatWeAreBuilding-module--arrow--3FY_c";